import { useCreatePeerNotification } from '@givebacks/api/notification';
import { useFormListValidation } from 'core/Hooks';
import { getErrorMessage_v2 } from 'core/Utils';
import { Modal, Stack, notifications } from 'ui';

import { DonationNotificationsForm } from '../../../molecules/forms/EditPeerPage/DonationNotificationsForm';
import { SetupPeerModalFormsType } from './SetupPeerPage.types';
import { SetupPeerPageModalFooter } from './SetupPeerPageModalFooter';
import {
  ModalTitleWithBackButton,
  useSetupPeerPageModalProvider,
} from './SetupPeerPageModalProvider';
import { SetupPeerPageStepper } from './SetupPeerPageStepper';

const SetupDonationNotificationsFooter = ({ openNextStep }: { openNextStep: () => void }) => {
  const { meta } = useSetupPeerPageModalProvider({});

  const { useGetForm } = useFormListValidation<SetupPeerModalFormsType>();
  const donationNotifications = useGetForm('donationNotifications');

  const { mutate: createPeerNotification } = useCreatePeerNotification({
    peerType: meta.peer.__type,
  });

  const handleSave = () => {
    if (donationNotifications.values.notifications === 'true') {
      createPeerNotification(
        {
          causeId: meta.campaign.cause_id,
          notification: {
            store_item_id: meta.campaign.uuid,
            participant_id: meta.peer.uuid,
          },
        },
        {
          onSuccess: () => {
            notifications.show({
              variant: 'success',
              message: 'Donation notifications settings updated',
            });
            openNextStep();
          },
          onError: (e) => {
            notifications.show({ variant: 'error', message: getErrorMessage_v2(e) });
            openNextStep();
          },
        }
      );
    } else {
      openNextStep();
    }
  };

  return <SetupPeerPageModalFooter onClick={handleSave} isShowSkip={false} />;
};

const SetupDonationNotificationsModal = () => {
  const { opened, closeAllModals, openNextStep, meta } = useSetupPeerPageModalProvider({
    id: 'notifications',
  });

  return (
    <Modal
      opened={opened}
      onClose={closeAllModals}
      title={<ModalTitleWithBackButton>Donation Notifications</ModalTitleWithBackButton>}
    >
      <Stack gap="lg">
        <SetupPeerPageStepper activeStep={2} />
        <DonationNotificationsForm
          participantId={meta.peer.uuid}
          causeId={meta.campaign.cause_id}
          peerType={meta.peer.__type}
        />
      </Stack>

      <SetupDonationNotificationsFooter openNextStep={openNextStep} />
    </Modal>
  );
};

export { SetupDonationNotificationsModal };
